<template>
  <div>
    <v-data-table
            :headers="headers"
            :items="items"
            :loading="loading"
            :options.sync="options"
            :server-items-length="serverItemsLength"
            class="elevation-1"
            loading-text="Traženje..."
            :footer-props="{itemsPerPageText: 'Redaka po stranici:'}"
            :header-props="{sortByText: 'Poredaj po'}">
        <template v-for="header in headers.slice(0, headers.length - 1)" v-slot:[`item.${header.value}`]="{ item }">
            <div :key="header.value">
                <a @click="readItem(item[header.value + '_route'], item[header.value + '_resourceId'])"
                   v-if="item[header.value + '_route']">
                    {{ item[header.value] }}
                </a>
                <span v-else style="color: black;">{{ item[header.value] }}</span>
            </div>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip bottom v-for="(action, i) in headers[headers.length - 1].buttons"
                       :key="i">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs"
                           v-on="on" class="mx-1" x-small min-height="30"
                           :color="action.icon === 'mdi-account-arrow-right' ? 'red' : 'primary'"
                           @click="handleAction(action.callback, item)">
                        <v-icon
                                ripple small class="pa-0" color="white"
                        >
                            {{ action.icon }}
                        </v-icon>
                    </v-btn>
                </template>
                <span v-if="action.icon == 'mdi-lock'">Dodijeli uloge</span>
                <span v-else-if="action.icon == 'mdi-magnify'">Detaljan pregled</span>
                <span v-else-if="action.icon == 'mdi-pencil'">Uredi</span>
                <span v-else-if="action.icon == 'mdi-account-arrow-right'">Ispiši učenika</span>
            </v-tooltip>
        </template>

        <template v-slot:no-data>
            <span>
                Za tražene pojmove nema rezultata pretrage.
            </span>
        </template>

        <template v-slot:footer.page-text="items"> Prikazano {{ items.pageStart }} do {{ items.pageStop }} od ukupno
            {{ items.itemsLength }} rezultata
        </template>

        <!--
        <template v-slot:footer.page-text>
            Showed {{ props.pageStart }} to {{ props.pageStop }} of total {{ props.itemsLength }} results
        </template>
        -->
    </v-data-table>
    <v-dialog
        v-model="dialog_removeRole"
        width="500">

      <v-card>
        <v-card-title
            primary-title>
          Jeste li sigurni?
        </v-card-title>

        <v-card-text style="padding-top: 20px;">
          Operacija koju ste zatražali može imati za posljedicu gubitak određenog dijela podataka. Jeste li sigurni da želite ispisati učenika iz Vaše škole?
          <br><br>
          <v-checkbox label="Prikaži učenika u izvještajima za ovu školsku godinu?" v-model="form.keep_student"></v-checkbox>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="(dialog_removeRole = false, form.keep_student = false)" depressed large outlined>Odustani</v-btn>
          <v-btn @click="deleteRole()" color="error" depressed large>Ispiši</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog v-model="pupilInClass"  width="500">
      <v-card >
        <v-card-title
            primary-title>
          Nije moguće izbrisati učenika iz škole!
        </v-card-title>

        <v-card-text style="padding-top: 20px;">
          Korisnik još uvijek postoji u razredu, te ga nije moguće izbrisati iz škole. Ukoliko želite izbrisati korisnika iz škole, prvo ste dužni izbrisati istog iz tekućeg razreda!
          <br><br>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="(pupilInClass = false, form.keep_student = false)" depressed large outlined>Odustani</v-btn>
          &nbsp;
          <router-link :to="`/admin/odjeljenje/pregled/${this.studentDepartment}`">
            <v-btn color="error" depressed large>Ispiši iz razreda!</v-btn>
          </router-link>

        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>

</template>

<script>
    import {serverBus} from "../../main";
    import ApiV2 from "../../services/ApiV2";

    export default {

        mounted: function () {
            this.getDataHeadersFromApi();
        },

        created() {
             if(localStorage.getItem('student-options')){
                this.options = JSON.parse(localStorage.getItem('student-options'));
                this.search = this.options.search
            }
            serverBus.$on('perform-search', (search_value) => {
                this.search = search_value;
            });

            serverBus.$on('filters-changed', (filters) => {
                this.options.filters = filters;
            });

            serverBus.$on('edit-item', (item) => {
                this.editItem(item);
            });

            serverBus.$on('delete-item', (item) => {

                this.deleteItem(item);
            });

            serverBus.$on(['reload-all-data', 'reload-table-data'], () => {
                this.search =  {
                    phrase: null,
                    field: null,
                }
                this.options.search = this.search
                serverBus.$emit('set-search', this.search)
                this.getDataFromApi();
            });
        },

        methods: {

            getDataFromApi() {
                this.loading = true;

                this.$axios.post(this.$getTable(), this.options).then(response => {
                    this.items = response.data.items;
                    this.serverItemsLength = response.data.totalItems;
                    let relations = response.data.relations;

                    for (let i = 0; i < this.items.length; i++) {
                        let item = this.items[i];
                        for (let j = 0; j < relations.length; j++) {
                            let relation = relations[j];

                            if (item[relation.key]) {
                                item[relation.column_show + "_route"] = relation.link;
                                item[relation.column_show + "_resourceId"] = item[relation.key];
                            }
                        }
                    }

                    this.$store.commit('setData', this.items);
                }).catch(() => {
                    this.items = [];
                }).finally(() => {
                    this.loading = false;
                });

            },

            goToRoute(itemId) {
                this.$router.push({name: 'SingleStudentTableView', params: {ucenik_id: `${itemId}`}})
            },

            getDataHeadersFromApi() {
                this.loading = true;

                this.$axios.post(this.$getTable() + '/zaglavlje').then(response => {
                    this.headers = response.data;

                    serverBus.$emit('headers-change', this.headers)
                    if(localStorage.getItem('student-options')){
                        let search = JSON.parse(localStorage.getItem('student-options')).search;
                        serverBus.$emit('set-search', search)
                    }
                }).finally(() => {
                    this.loading = false
                });
            },

          deleteRole() {



                ApiV2.post('roles/revoke_user_role', this.form).then(() => {
                  this.getDataFromApi()
                });


                this.form.keep_student = false;
                this.dialog_removeRole = false;


          },

            handleAction(action, item) {
              if(action === 'delete-item'){
                let model_id = null

                let requestData = {
                  school_id: localStorage.getItem('school_id'),
                  school_year_id: localStorage.getItem('school_year_id'),
                  id: item.id,
                }
                ApiV2.post(`department_enrollment/is_enrolled_in_department`, requestData).then(response => {
                  if(response.data === -1){

                    this.$axios.post('ostalo/uloga/korisnik/' + item.id)
                        .then(response => {
                          let role = response.data
                          for (var prop in role) {
                            if (role[prop].role_id === 10) {
                              model_id = role[prop].id
                            }
                          }
                          this.user_id = item.id
                          this.form.model_has_role_id = model_id;
                          this.dialog_removeRole = true;
                        })
                  }else {
                    this.pupilInClass = true;
                    this.studentDepartment = response.data[0].department_id;

                  }
                }).catch(error =>{
                  console.error('Greška prilikom dohvaćanja podataka', error);
                });

              } else {
                serverBus.$emit(action, item);
              }
            },

            readItem(table, resourceId) {
                let resource = {id: resourceId};

                serverBus.$emit('show-add-edit-dialog', table, resource);
            },

            editItem(item) {
                serverBus.$emit('show-student-add-form', item);
            },

            deleteItem(item) {
                serverBus.$emit('show-delete-item-dialog', this.$getTable(), item);
            },
        },

        watch: {
            options: {
                handler() {
                    this.options.search = this.search;
                    /*
                    if (this.options.itemsPerPage === -1) {
                        serverBus.$emit('show-all-rows-warning');
                        return;
                    }
                     */
                    localStorage.setItem('student-options', JSON.stringify(this.options));
                    this.getDataFromApi();
                },
                deep: true
            },

            search: {
                handler() {
                    if (this.search.field !== null && this.search.phrase !== null) {
                        let self = this;

                        self.loading = true;

                        clearTimeout(self.request);

                        self.request = null;
                        self.request = setTimeout(function () {
                            self.options.search = self.search;
                            localStorage.setItem('student-options', JSON.stringify(self.options));
                            self.getDataFromApi();
                        }, 300);
                    }
                },
                deep: true
            },
        },

        beforeDestroy() {
            this.$destroyEvents();

            serverBus.$off('perform-search');
            serverBus.$off('filters-changed');
            serverBus.$off('edit-item');
            serverBus.$off('delete-item');
            serverBus.$off('reload-all-data');
            serverBus.$off('reload-table-data');
        },

        data: function () {
            return {
                items: [],
                headers: [],
                user_id: null,
                form: {},
                dialog_removeRole: false,
                request: null,
                search: {
                    phrase: null,
                    field: null
                },
                options: {
                    filters: {},
                    itemsPerPage: 10,
                },
                loading: true,
                serverItemsLength: 0,
              pupilInClass: false,
              studentDepartment: null,
            }
        },

    }
</script>
